<script type="text/jsx">
    export default {
        name: 'physical-key',
        methods: {
            backChange() {
                this.$emit('back-event-handler');
            }
        },
        destroyed() {
            window.removeEventListener('popstate', this.backChange, false);//false阻止默认事件
        },
        mounted(){
            // 如果支持 popstate 一般移动端都支持了
            if (window.history && window.history.pushState) {
                // 往历史记录里面添加一条新的当前页面的url
                //history.pushState(null, null, document.URL);
                history.pushState(null, null, null);
                // 给 popstate 绑定一个方法
                window.addEventListener('popstate', this.backChange, false);//false阻止默认事件
            }
        },
        render() {
            return (<div></div>);
        }
    }
</script>